import { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Grid,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import { useLotteries } from "../../hooks/useLotteries";
import { RunLotteryDrawAnimation } from "./RunLotteryDrawAnimation";
import { RunLotteryResults } from "./RunLotteryResults";
import { useDraw } from "../../hooks/useDraw";
import { RunLotteryDetails } from "./RunLotteryDetails";
import {
  EmojiEvents as TrophyIcon,
  Casino as CasinoIcon,
} from "@mui/icons-material";
import { RunLotteryDrawnPrizes } from "./RunLotteryDrawnPrizes";

const TabPanel: React.FC<any> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
  </div>
);

export const RunLotteryContainer = () => {
  const [selectedLotteryId, setSelectedLotteryId] = useState("");
  const [animationEneded, setAnimationEnded] = useState(true);
  const { lotteries, refetch } = useLotteries();
  const [tabValue, setTabValue] = useState(0);
  const { loading, runDraw, winningPrizes } = useDraw();
  const selectedLottery = lotteries.find(
    (lottery) => lottery.sessionId === selectedLotteryId
  );

  useEffect(() => {
    refetch();
  }, [refetch, winningPrizes]);

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2} sx={{ mt: 4 }}>
        <Grid size={12}>
          <Paper sx={{ p: 3, borderRadius: 4 }}>
            <Typography
              variant="h2"
              sx={{
                fontFamily: '"Mountains of Christmas", cursive',
                color: "hsl(350, 80%, 40%)",
                textAlign: "center",
                fontSize: { xs: "2rem", md: "2.5rem" },
              }}
            >
              🎰 Διεξαγωγή Λοταρίας 🎰
            </Typography>
          </Paper>
        </Grid>
        <Grid size={3}>
          <RunLotteryDetails
            selectedLotteryId={selectedLotteryId}
            lotteries={lotteries}
            selectedLottery={selectedLottery!}
            setSelectedLotteryId={setSelectedLotteryId}
          />
        </Grid>
        <Grid size={9}>
          <Tabs
            value={tabValue}
            onChange={(_, newValue) => setTabValue(newValue)}
            sx={{
              borderRadius: 2,
              bgcolor: "hsla(150, 52%, 24%, 1.00)",
              "& .MuiTab-root": {
                color: "hsl(150, 20%, 70%)",
                fontSize: "1em",
                fontWeight: "bold",
                "&.Mui-selected": {
                  color: "hsl(45, 90%, 65%)",
                },
              },
              "& .MuiTabs-indicator": {
                bgcolor: "hsl(45, 90%, 65%)",
              }
            }}
          >
            <Tab label="Λοταρια" icon={<CasinoIcon />} iconPosition="start" />
            {selectedLottery && (
              <Tab
                label={`Αποτελεσματα Λοταριας`}
                icon={<TrophyIcon />}
                iconPosition="start"
              />
            )}
          </Tabs>
          <TabPanel value={tabValue} index={0}>
            {!loading && animationEneded && winningPrizes.length > 0 && (
              <RunLotteryResults
                prizes={winningPrizes ?? []}
                reRunLottery={null}
              />
            )}
            <RunLotteryDrawAnimation
              selectedLottery={selectedLottery!}
              setAnimationEnded={setAnimationEnded}
              runDraw={runDraw}
            />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <RunLotteryDrawnPrizes selectedLottery={selectedLottery!} />
          </TabPanel>
        </Grid>
      </Grid>
    </Container>
  );
};
